import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t border-primary/10 pt-16 pb-10 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Main footer row */}
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
          {/* Brand */}
          <div className="lg:max-w-xs">
            <div className="flex items-center gap-2.5 mb-4">
              <AppLogo size={28} />
              <span className="font-sans text-sm font-semibold tracking-widest uppercase text-foreground">
                Aregn Capital
              </span>
            </div>
            <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
              Capital. Connections. Conviction.
            </p>
          </div>

          {/* Link clusters — no headers, spacing creates grouping */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 text-sm text-muted-foreground">
            <div className="space-y-3">
              <Link
                href="/about"
                className="block font-medium hover:text-foreground transition-colors"
              >
                About Us
              </Link>
              <Link
                href="/#approach"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Our Approach
              </Link>
              <Link
                href="/#track-record"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Track Record
              </Link>
            </div>
            <div className="space-y-3">
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Raise Capital
              </Link>
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Submit Company
              </Link>
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Investor Network
              </Link>
            </div>
            <div className="space-y-3">
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Join Network
              </Link>
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Deal Flow
              </Link>
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Opportunities
              </Link>
            </div>
            <div className="space-y-3">
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Contact Us
              </Link>
              <Link
                href="/contact"
                className="block font-medium hover:text-foreground transition-colors"
              >
                Partnerships
              </Link>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-primary/10 pt-8 mb-6">
          <p className="text-xs text-muted-foreground leading-relaxed max-w-4xl">
            Aregn Capital facilitates connections and provides strategic support around fundraising
            and investor relationships. Any investment decision is made independently by the
            relevant investor. Past activity or track record is not indicative of future results.
            Information presented on this website does not constitute an offer, solicitation or
            recommendation to buy or sell securities or investment advice.
          </p>
        </div>

        <p className="text-xs text-muted-foreground leading-relaxed mb-6">
          Aregn Capital is a brand of Aregn Ventures Private Limited.
        </p>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© 2026 Aregn Capital. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link href="#" className="hover:text-foreground transition-colors font-medium">
              Privacy Policy
            </Link>
            <Link href="#" className="hover:text-foreground transition-colors font-medium">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
